// Each failure gives an empty store, and the kiosk continues. The failures are
// an exception from the storage, a value that is not JSON, and an exception in
// parse. parse gives null for a parsed value that it cannot use.
export function jsonStorageStore<T>(
  storage: Storage | undefined,
  key: string,
  parse: (parsed: Partial<T>) => T | null
): { read(): T | null; write(value: T): void; clear(): void } {
  return {
    read() {
      try {
        const raw = storage?.getItem(key);
        if (!raw) return null;
        return parse(JSON.parse(raw));
      } catch {
        return null;
      }
    },
    write(value) {
      try {
        storage?.setItem(key, JSON.stringify(value));
      } catch {
        // The kiosk can continue without recovery after a reload.
      }
    },
    clear() {
      try {
        storage?.removeItem(key);
      } catch {
        // The kiosk can continue without recovery after a reload.
      }
    },
  };
}
